import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonVariant } from '../../../components/common/Button'
import {
  Illustration,
  IllustrationChoices,
} from '../../../components/common/Illustration'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { theme } from '../../../theme/theme'
import { i18nSocietyType } from '../../../i18n'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'

export const ActivatedSocietyConfirmationView = (): React.ReactNode => {
  const navigate = useNavigate()
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(reverseDocumentTitle('activated-society'))

  const navigateToSociety = (): void => {
    navigate(reverseUrl('society'), { replace: true })
  }

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <Illustration illustrationChoice={IllustrationChoices.WINNERS} />
      <div className="mt-10 flex w-[500px] flex-col items-start">
        <p style={theme.textVariants.h1}>
          {translate('activatedSocietyConfirmationView.title', {
            context: i18nSocietyType(society?.societyTypeDisplayName),
          })}
        </p>
        <p className="mb-10 mt-4" style={theme.textVariants.base}>
          {translate('activatedSocietyConfirmationView.subtitle')}
        </p>
        <Button
          className="w-full"
          wrapperClassName="w-full"
          variant={ButtonVariant.PRIMARY}
          onClick={navigateToSociety}
          label={translate('activatedSocietyConfirmationView.buttonTitle')}
        />
      </div>
    </div>
  )
}
